import { Button, Divider, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import update from "../../../api/auth/items/itemBookableDurations/update";
import useBookableDurationStore from "../../../stores/useBookableDurationStore";
import WushTextField from "../WushTextField";
import WushYesNoField from "../WushYesNoField";
import ItemAvailabilitiesForm from "./ItemAvailabilitiesForm";

export default function ItemBookableDurationForm({itemBookableDuration}){
  const { register, handleSubmit } = useForm();

  const { updateItemBookableDuration } = useBookableDurationStore();

  const onSubmit = (values) => {
    update(itemBookableDuration.item_id, itemBookableDuration.id, values, (response) => {
      updateItemBookableDuration(response);
    });
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={2}>
          <Stack>
            <WushTextField formRegistration={register("name")} label="Name" defaultValue={itemBookableDuration.name || itemBookableDuration?.bookable_duration?.name} />
          </Stack>
          <Stack>
            <WushTextField formRegistration={register("price")} label="Price" type="number" defaultValue={itemBookableDuration.price_dollars} />
          </Stack>
          <Stack>
            <WushYesNoField formRegistration={register("default_available")} label="Default Available" defaultValue={itemBookableDuration.default_available} />
          </Stack>
          <Stack my={2}>
            <Divider />
          </Stack>
          <Stack>
            <ItemAvailabilitiesForm itemBookableDuration={itemBookableDuration} />
          </Stack>
          <Stack>
            <Button variant="contained" type="submit">Save</Button>
          </Stack>
        </Stack>
      </form>
    </Stack>
  );
}